/**
 * Store launch state — the single switch for real billing.
 *
 * Until RevenueCat goes live with the Play Store launch, the app must
 * NEVER present a purchase button to the public: the alpha mock provider
 * "succeeds" without charging, which would silently give premium away and
 * throw away real purchase intent (Chad, 31 Jul). Pre-launch, every
 * purchase surface converts that intent into a LAUNCH WAITLIST signup
 * instead. Invite-code redemption (lifetime access) is unaffected.
 *
 * Flip STORE_BILLING_LIVE to true in the RevenueCat rollout — purchase
 * buttons reactivate everywhere at once.
 */
// Flipped 26 Sept 2026 for build 17 (internal testing → production on flip day).
export const STORE_BILLING_LIVE = true;

/** Marketing-site waitlist anchor (same origin as the app). */
export const WAITLIST_URL = '/home.html#waitlist';

/** One sentence, used on every gated purchase surface. */
export const PRELAUNCH_NOTE =
  'Premium arrives with the September launch — waitlist members get the launch-window offer first.';

/**
 * Settings footer, public-facing. Until 12 Sept 2026 this read "Billing:
 * mock mode (no real charges)" on the LIVE app — development copy that the
 * public could see. It now follows the flag, so it flips with everything
 * else in SEAM_REGISTRY seam 6.
 */
export const BILLING_FOOTER = STORE_BILLING_LIVE
  ? 'Billing via Google Play'
  : 'Premium coming soon';
